export enum MicrophoneStatusEnum {
  Active = "active",
  Inactive = "inactive",
}

export type MicrophoneStatus = MicrophoneStatusEnum;
